import React, { useState } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import Card from "./Card";

const Testimonials = (props) => {
    const reviews = props.reviews;
    const [index, setIndex] = useState(0);

    function leftShiftHandler() {
        if (index - 1 < 0) {
            setIndex(reviews.length - 1);
        } else {
            setIndex(index - 1);
        }
    }

    function rightShiftHandler() {
        if (index + 1 >= reviews.length) {
            setIndex(0);
        } else {
            setIndex(index + 1);
        }
    }

    return (
        <div className="impact-testimonials-shell">
            <Card review={reviews[index]} />

            <div className="impact-testimonials-nav" aria-label="Testimonial navigation">
                <button
                    type="button"
                    onClick={leftShiftHandler}
                    className="impact-testimonials-btn"
                    aria-label="Previous testimonial"
                >
                    <FiChevronLeft />
                </button>
                <button
                    type="button"
                    onClick={rightShiftHandler}
                    className="impact-testimonials-btn"
                    aria-label="Next testimonial"
                >
                    <FiChevronRight />
                </button>
            </div>
        </div>
    );
};

export default Testimonials;
